import React from 'react';

const Banner = () =>{
    return(
        <div id = "banner">
        <div id = "overlay">
            <div id = "topic">
            30 DAYS GOOGLE CLOUD CHALLENGE
            </div>
        </div>
        <img id = "gdsc-banner" alt = "GDSC-Banner" 
        src = "https://res.cloudinary.com/startup-grind/image/upload/c_fill,dpr_2.0,f_auto,g_xy_center,h_650,q_auto:good,w_2560,x_w_mul_0.5,y_h_mul_0.61/v1/gcs/platform-data-dsc/chapter_banners/Copy%20of%20Google%20Developer%20%20Student%20Clubs%20Chapter_%20Youtube%20Banners.png?lg"/>
        </div>
    );
};

export default Banner;